module.exports = __WEBPACK_EXTERNAL_MODULE__4994__;